/* src/app/views/collection/components/modals/required-display-edit-method/required-display-edit-method.component.scss */
.required-display-edit-method-container {
  padding-inline: 0.2rem;
}
/*# sourceMappingURL=required-display-edit-method.component.css.map */
